import img_loading from "@/Globals/_images/loading.gif";

interface IInformationLoadingComponenProps {
    cssClass?: string;
    smallVersion?: boolean;
    customMessage?: string;
    showLoadingImageOnly?: boolean;
}

class InformationLoadingComponent extends React.Component<IInformationLoadingComponenProps, never> {
    public render(): JSX.Element {
        if (this.props.showLoadingImageOnly)
            return this.renderLoadIndicator();

        return this.props.smallVersion
            ? this.renderSmall()
            : this.renderBig();
    }

    private renderLoadIndicator(): JSX.Element {
        return <img src={img_loading} />;
    }

    private renderBig(): JSX.Element {
        return (
            <div className={this.props.cssClass}>
                <div className="flex-container centered">
                    <h3 className="thin-font">{this.props.customMessage}</h3>
                </div>
                <div className="flex-container centered">
                    {this.renderLoadIndicator()}
                </div>
            </div>
        );
    }

    private renderSmall(): JSX.Element {
        return (
            <div className={this.props.cssClass}>
                <div className="flex-container centered">
                    {this.renderLoadIndicator()}
                    {this.props.customMessage != null && this.props.customMessage.length > 0 &&
                        <span style={{ paddingLeft: "10px" }}>{this.props.customMessage}</span>
                    }
                </div>
            </div>
        );
    }
}

export { InformationLoadingComponent };
